/** 汎用ユーティリティ（クラス結合・フォーマッタなどの小物関数）。 */
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
